module.exports = __webpack_public_path__ + "img/icon_password_eye_colse.ef7b1def.png";